import { createSelector } from "reselect";

import { illustoProjectSlice } from "./slice";

const selectIllustoProjectState = (state) => state[illustoProjectSlice.name];

export const selectIllustoProjectDetails = createSelector(
  selectIllustoProjectState,
  (illustoProjectState) => illustoProjectState.projectDetails,
);
export const selectIllustoClipsProgress = createSelector(
  selectIllustoProjectState,
  (illustoProjectState) => illustoProjectState.illustoClipsProgress,
);
export const selectProjectInPublishModal = createSelector(
  selectIllustoProjectState,
  (illustoProjectState) => illustoProjectState.projectInPublishModal,
);
export const selectIsStreamIndependent = createSelector(
  selectIllustoProjectState,
  (_, props) => props.isStreamIndependentProp, // this will be considered if we want to hardcode the isStreamIndependent value to true
  (illustoProjectState, isStreamIndependentProp) => isStreamIndependentProp || illustoProjectState.isStreamIndependet,
);
